import { SidebarMenuItem } from "../../Types/Layout.type";

/**
 * Returns the first route path the user has permission to view, in menu order.
 * Falls back to "/home" if no permissions or no permitted route.
 */
export function getFirstPermissionRoute(
  permissions: Record<string, { view?: boolean }> | null | undefined,
): string {
  if (!permissions || typeof permissions !== "object") return "/home";

  for (const mainMenu of menuList) {
    for (const item of mainMenu.items || []) {
      const permKey = (item as any).permission;
      if (
        permKey &&
        permissions[permKey]?.view === true &&
        (item as any).path
      ) {
        return (item as any).path;
      }
    }
  }
  return "/home";
}

export const menuList: SidebarMenuItem[] = [
  {
    title: "General",
    lanClass: "lan-1",
    items: [
      {
        path: `/dashboard`,
        icon: "Chart",
        type: "link",
        title: "Dashboard",
        id: 9,
        permission: "dashboard",
      },
      {
        path: `/data-pipeline`,
        icon: "Filter",
        type: "link",
        title: "Data Pipeline",
        id: 152317,
        permission: "dashboard",
      },
      {
        path: `/brand-requests`,
        icon: "brand-requests",
        type: "link",
        title: "Brand Requests",
        id: 152316,
        permission: "brand_requests",
      },
      {
        path: `/brands`,
        title: "Brands",
        icon: "Bag",
        type: "link",
        id: 11,
        permission: "brands",
      },
      {
        path: `/retailers`,
        icon: "Chart",
        type: "link",
        title: "Retailers",
        id: 323,
        permission: "retailers",
      },
      {
        path: `/update-verifications`,
        icon: "Edit",
        type: "link",
        title: "Verifications",
        id: 545,
        permission: "verifications",
      },
      {
        path: `/queues`,
        icon: "Tick-square",
        type: "link",
        title: "Queues",
        id: 56,
        permission: "queues",
      },
      {
        path: `/management`,
        icon: "Setting",
        type: "link",
        title: "Management",
        id: 1123,
        permission: "management",
      },
      {
        path: `/discount-coupons`,
        icon: "Ticket-star",
        type: "link",
        title: "Discount Coupons",
        id: 1124,
        permission: "management",
      },
      {
        path: `/seasonal-pass-links`,
        icon: "Ticket-star",
        type: "link",
        title: "Seasonal Pass Links",
        id: 1126,
        permission: "management",
      },
      {
        path: `/website-leads`,
        icon: "Contacts",
        type: "link",
        title: "Website Leads",
        id: 1125,
        permission: "management",
      },
      {
        path: `/invite`,
        icon: "Profile",
        type: "link",
        title: "Invite Organization",
        id: 1454,
        permission: "invite",
      },
      {
        path: `/plan-requests`,
        icon: "Shield",
        type: "link",
        title: "Plan Requests",
        id: 14454,
        permission: "plan_requests",
      },
      {
        path: `/pitti-invite`,
        icon: "Profile",
        type: "link",
        title: "Pitti Invite",
        id: 14223,
        permission: "pitti_invite",
      },
      {
        path: `/invite-user`,
        icon: "Filter",
        type: "link",
        title: "Invite User",
        id: 14424,
        permission: "invite_user",
      },
      {
        path: `/admin-users`,
        icon: "Shield",
        type: "link",
        title: "Admin Users",
        id: 152314,
        permission: "admin_users",
      },
      {
        path: `/ai-knowledge-base`,
        icon: "Upload",
        type: "link",
        title: "Train Vionne",
        id: 152315,
        permission: "ai_knowledge_base",
      },
      // {
      //   path: `/home`,
      //   icon: "Pie",
      //   type: "link",
      //   title: "Companies",
      //   id: 10,
      //   permission: "companies",
      // },
    ],
  },
  // {
  //     title: "Application",
  //     items: [
  //         // {
  //         //     title: "Project",
  //         //     id: 3,
  //         //     icon: "Info-circle",
  //         //     type: "sub",
  //         //     active: false,
  //         //     children: [
  //         //         { path: `/project/project_list`, type: "link", title: "Project list" },
  //         //         { path: `/project/create_new`, type: "link", title: "Project create" },
  //         //     ],
  //         // },
  //         // { path: `/app/file_manager`, icon: "Paper", title: "File Manager", type: "link" },
  //         // {
  //         //     title: "Ecommerce",
  //         //     id: 6,
  //         //     icon: "Bag",
  //         //     type: "sub",
  //         //     active: false,
  //         //     children: [
  //         //         { path: `/ecommerce/add_product`, title: "Add Products", type: "link" },
  //         //         { path: `/ecommerce/product`, title: "Product", type: "link" },
  //         //         { path: `/ecommerce/product_page`, title: "Product Page", type: "link" },
  //         //         { path: `/ecommerce/category_page`, title: "Category Page", type: "link" },
  //         //         { path: `/ecommerce/product_list`, title: "Product List", type: "link" },
  //         //         { path: `/ecommerce/payment_details`, title: "Payment Details", type: "link" },
  //         //         { path: `/ecommerce/order_history`, title: "Order History", type: "link" },
  //         //         {
  //         //             title: "Invoices",
  //         //             type: "sub",
  //         //             children: [
  //         //                 { path: `/ecommerce/invoice/invoice1`, title: "Invoice 1", type: "link" },
  //         //                 { path: `/ecommerce/invoice/invoice2`, title: "Invoice 2", type: "link" },
  //         //                 { path: `/ecommerce/invoice/invoice3`, title: "Invoice 3", type: "link" },
  //         //                 { path: `/ecommerce/invoice/invoice4`, title: "Invoice 4", type: "link" },
  //         //                 { path: `/ecommerce/invoice/invoice5`, title: "Invoice 5", type: "link" },
  //         //                 { path: `/ecommerce/invoice/invoice6`, title: "Invoice 6", type: "link" },
  //         //             ],
  //         //         },
  //         //         { path: `/ecommerce/cart`, title: "Cart", type: "link" },
  //         //         { path: `/ecommerce/wishlist`, title: "Wishlist", type: "link" },
  //         //         { path: `/ecommerce/checkout`, title: "Checkout", type: "link" },
  //         //         { path: `/ecommerce/pricing`, title: "Pricing", type: "link" },
  //         //     ],
  //         // },
  //         // { path: `/email/letter_box`, icon: "Message", title: "Letter Box", type: "link", id: 7 },
  //         // {
  //         //     title: "Chat",
  //         //     id: 8,
  //         //     icon: "Chat",
  //         //     type: "sub",
  //         //     active: false,
  //         //     children: [
  //         //         { path: `/chat/private_chat`, type: "link", title: "Private Chat" },
  //         //         { path: `/chat/group_chat`, type: "link", title: "Group Chat" },
  //         //     ],
  //         // },
  //         // {
  //         //     title: "Users",
  //         //     icon: "Profile",
  //         //     type: "sub",
  //         //     active: false,
  //         //     children: [
  //         //         { path: `/users/user_profile`, type: "link", title: "User Profile" },
  //         //         { path: `/users/user_edit`, type: "link", title: "User Edit" },
  //         //         { path: `/users/cards`, type: "link", title: "User Cards" },
  //         //     ],
  //         // },
  //         // { path: `/app/bookmark`, icon: "Bookmark", type: "link", title: "Bookmarks", id: 10, bookmark: true, },
  //         // { path: `/app/contacts`, title: "Contacts", icon: "Contacts", type: "link", id: 11, active: false },
  //         // { path: `/app/task`, icon: "Tick-square", type: "link", title: "Tasks", id: 12 },
  //         // { path: `/app/calendar`, icon: "Calendar", type: "link", title: "Calendar", id: 13 },
  //         // { path: `/app/social_app`, icon: "Camera", type: "link", title: "Social App", id: 14, bookmark: true, },
  //         // { path: `/app/todo`, icon: "Edit", type: "link", title: "To-Do", id: 15, bookmark: true, },
  //         // { path: `/app/search_result`, icon: "Search-sidebar", type: "link", title: "Search Result", id: 16 },
  //     ],
  // },
  // {
  //     title: "Components",Filter
  //     items: [
  //         { path: `/buttons`, icon: "More-box", title: "Buttons", type: "link", id: 17 },
  //         {
  //             title: "Ui Kits",
  //             icon: "Folder",
  //             id: 18,
  //             type: "sub",
  //             active: false,
  //             children: [
  //                 { path: `/ui_kits/typography`, title: "Typography", type: "link" },
  //                 { path: `/ui_kits/avatars`, title: "Avatars", type: "link" },
  //                 { path: `/ui_kits/alert`, title: "Alert", type: "link" },
  //                 { path: `/ui_kits/helperclass`, title: "Helper Classes", type: "link" },
  //                 { path: `/ui_kits/grid`, title: "Grid", type: "link" },
  //                 { path: `/ui_kits/accordion`, title: "Accordion", type: "link" },
  //                 { path: `/ui_kits/tagpills`, title: "Tag & Pills", type: "link" },
  //                 { path: `/ui_kits/modal`, title: "Modal", type: "link" },
  //                 { path: `/ui_kits/popover`, title: "Popover", type: "link" },
  //                 { path: `/ui_kits/progress`, title: "Progress Bar", type: "link" },
  //                 { path: `/ui_kits/tabs`, title: "Tab Bootstrap", type: "link" },
  //                 { path: `/ui_kits/tooltip`, title: "Tooltip", type: "link" },
  //                 { path: `/ui_kits/dropdown`, title: "Dropdown", type: "link" },
  //                 { path: `/ui_kits/list`, title: "List", type: "link" },
  //             ],
  //         },
  //         {
  //             title: "Bonus Ui",
  //             icon: "Ticket-star",
  //             id: 19,
  //             type: "sub",
  //             active: false,
  //             children: [
  //                 { path: `/bonus_ui/scrollable`, title: "Scrollable", type: "link" },
  //                 { path: `/bonus_ui/tree_view`, title: "Tree View", type: "link" },
  //                 { path: `/bonus_ui/toasts`, title: "Toasts", type: "link" },
  //                 { path: `/bonus_ui/rating`, title: "Rating", type: "link" },
  //                 { path: `/bonus_ui/dropzone`, title: "Dropzone", type: "link" },
  //                 { path: `/bonus_ui/tour`, title: "Tour ", type: "link" },
  //                 { path: `/bonus_ui/sweet_alert2`, title: "SweetAlert2", type: "link" },
  //                 { path: `/bonus_ui/slider`, title: "Slider", type: "link" },
  //                 { path: `/bonus_ui/ribbons`, title: "Ribbons", type: "link" },
  //                 { path: `/bonus_ui/pagination`, title: "Pagination", type: "link" },
  //                 { path: `/bonus_ui/breadcrumb`, title: "Breadcrumb", type: "link" },
  //                 { path: `/bonus_ui/range_slider`, title: "Range Slider", type: "link" },
  //                 { path: `/bonus_ui/image_cropper`, title: "Image Cropper", type: "link" },
  //                 { path: `/bonus_ui/basic_cards`, title: "Basic Card", type: "link" },
  //                 { path: `/bonus_ui/creative_cards`, title: "Creative Card", type: "link" },
  //                 { path: `/bonus_ui/timeline`, title: "Timeline", type: "link" },
  //             ],
  //         },
  //         {
  //             title: "Icons",
  //             icon: "Activity",
  //             id: 20,
  //             type: "sub",
  //             active: false,
  //             children: [
  //                 { path: `/icons/fontawesome_icon`, title: "Fontawesome Icon", type: "link" },
  //                 { path: `/icons/feather_icon`, title: "Feather Icon", type: "link" },
  //                 { path: `/icons/iconly_icon`, title: "Iconly Icon", type: "link" },
  //                 { path: `/icons/themify_icon`, title: "Themify Icon", type: "link" },
  //             ],
  //         },
  //         {
  //             title: "Charts",
  //             icon: "Chart",
  //             type: "sub",
  //             id: 21,
  //             active: false,
  //             children: [
  //                 { path: `/charts/apex_chart`, type: "link", title: "Apex Chart" },
  //                 { path: `/charts/google_chart`, type: "link", title: "Google Chart" },
  //                 { path: `/charts/chartjs_chart`, type: "link", title: "Chartjs Chart" },
  //             ],
  //         },
  //     ],
  // },
  // {
  //     title: "Tables & Forms",
  //     items: [
  //         {
  //             title: "Forms",
  //             id: 22,
  //             icon: "Filter",
  //             type: "sub",
  //             active: false,
  //             children: [
  //                 {
  //                     title: "Form Controls",
  //                     type: "sub",
  //                     children: [
  //                         { title: "Base Inputs", type: "link", path: `/forms/forms_controls/base_input` },
  //                         { title: "Form Validation", type: "link", path: `/forms/forms_controls/form_validation` },
  //                         { title: "Checkbox & Radio", type: "link", path: `/forms/forms_controls/radio_checkbox` },
  //                         { title: "Input Groups", type: "link", path: `/forms/forms_controls/input_groups` },
  //                         { title: "Input Mask", type: "link", path: `/forms/forms_controls/input_mask` },
  //                         { title: "Mega Option", type: "link", path: `/forms/forms_controls/mega_option` },
  //                     ],
  //                 },
  //                 {
  //                     title: "Form Widget",
  //                     type: "sub",
  //                     children: [
  //                         { title: "Datepicker", type: "link", path: `/forms/forms_widget/datepicker` },
  //                         { title: "Touchspin", type: "link", path: `/forms/forms_widget/touchspin` },
  //                         { title: "Switch", type: "link", path: `/forms/forms_widget/switch` },
  //                         { title: "Typeahead", type: "link", path: `/forms/forms_widget/typeahead` },
  //                         { title: "Clipboard", type: "link", path: `/forms/forms_widget/clipboard` },
  //                     ],
  //                 },
  //                 {
  //                     title: "Form Layout",
  //                     type: "sub",
  //                     children: [
  //                         { path: `/forms/forms_layout/form_wizard_1`, title: "Form Wizard 1", type: "link" },
  //                         { path: `/forms/forms_layout/form_wizard_2`, title: "Form Wizard 2", type: "link" },
  //                         { path: `/forms/forms_layout/two_factor`, title: "Two factor", type: "link" },
  //                     ],
  //                 },
  //             ],
  //         },

  //         {
  //             title: "Tables",
  //             icon: "Edit-line",
  //             id: 23,
  //             type: "sub",
  //             children: [
  //                 {
  //                     title: "Reactsrap Tables",
  //                     type: "sub",
  //                     children: [
  //                         {
  //                             title: "Basic Tables",
  //                             type: "link",
  //                             path: `/table/reactstrap_table/basic_table`,

  //                         },
  //                         {
  //                             title: "Table Components",
  //                             type: "link",
  //                             path: `/table/reactstrap_table/table_component`,
  //                         },
  //                     ],
  //                 },
  //                 {
  //                     title: "Data Tables",
  //                     type: "sub",
  //                     children: [
  //                         { path: `/table/data_table/basic_init`, title: "Basic Init", type: "link" },
  //                         { path: `/table/data_table/advance_init`, title: "Advance Init", type: "link" },
  //                         { path: `/table/data_table/api`, title: "API", type: "link" },
  //                         { path: `/table/data_table/data_sources`, title: "Data Source", type: "link" },
  //                     ],
  //                 },
  //             ],
  //         },
  //     ],
  // },
  // {
  //     title: "Pages",
  //     items: [
  //         {
  //             icon: "Paper-plus",
  //             id: 24,
  //             active: false,
  //             path: `/pages/sample_page`,
  //             title: "Sample Page",
  //             type: "link",
  //         },
  //         {
  //             title: "Others",
  //             icon: "Password",
  //             id: 25,
  //             type: "sub",
  //             children: [
  //                 {
  //                     title: "Error Pages",
  //                     type: "sub",
  //                     children: [
  //                         { title: "Error page 1", type: "link", path: `/errors/error_400` },
  //                         { title: "Error page 2", type: "link", path: `/errors/error_401` },
  //                         { title: "Error page 3", type: "link", path: `/errors/error_403` },
  //                         { title: "Error page 4", type: "link", path: `/errors/error_404` },
  //                         { title: "Error page 5", type: "link", path: `/errors/error_500` },
  //                         { title: "Error page 6", type: "link", path: `/errors/error_503` },
  //                     ],
  //                 },
  //                 {
  //                     title: "Authentication",
  //                     type: "sub",
  //                     children: [
  //                         { title: "Login Simple", type: "link", path: `/authentication/login_simple` },
  //                         { title: "Login with bg image", type: "link", path: `/authentication/login_bg_image` },
  //                         { title: "Login with image two", type: "link", path: `/authentication/login_with_image_two` },
  //                         { title: "Login with validation", type: "link", path: `/authentication/login_validation` },
  //                         { title: "Login with tooltip", type: "link", path: `/authentication/login_tooltip` },
  //                         { title: "Login with sweetalert", type: "link", path: `/authentication/login_sweetalert` },
  //                         { title: "Register Simple", type: "link", path: `/authentication/register_simple` },
  //                         { title: "Register with Bg Image", type: "link", path: `/authentication/register_bg_image` },
  //                         { title: "Register with Bg Two", type: "link", path: `/authentication/register_with_image_two` },
  //                         { title: "Register Wizard", type: "link", path: `/authentication/register_wizard` },
  //                         { title: "Unlock User", type: "link", path: `/authentication/unlock_user` },
  //                         { title: "Forget Password", type: "link", path: `/authentication/forget_password` },
  //                         { title: "Reset Password", type: "link", path: `/authentication/reset_password` },
  //                         { title: "Maintenance", type: "link", path: `/authentication/maintenance` },
  //                     ],
  //                 },
  //                 {
  //                     title: "Coming Soon",
  //                     type: "sub",
  //                     children: [
  //                         { title: "Coming Simple", type: "link", path: `/comingsoon/coming_soon_simple` },
  //                         { title: "Coming with Bg Video", type: "link", path: `/comingsoon/coming_bg_video` },
  //                         { title: "Coming with bg Image", type: "link", path: `/comingsoon/coming_bg_img` },
  //                     ],
  //                 },
  //             ],
  //         },
  //     ],
  // },
  // {
  //     title: "Miscellaneous",
  //     items: [
  //         {
  //             title: "Gallery",
  //             icon: "Gallery",
  //             id: 26,
  //             type: "sub",
  //             active: false,
  //             children: [
  //                 { path: `/gallery/gallery_grids`, title: "Gallery Grid", type: "link" },
  //                 { path: `/gallery/gallery_grid_desc`, title: "Gallery Grid Desc", type: "link" },
  //                 { path: `/gallery/masonry_gallery`, title: "Masonry Gallery", type: "link" },
  //                 { path: `/gallery/masonry_with_desc`, title: "Masonry With Desc", type: "link" },
  //                 { path: `/gallery/hover_effect`, title: "Hover Effects", type: "link" },
  //             ],
  //         },
  //         {
  //             title: "Blog",
  //             icon: "Game",
  //             id: 27,
  //             type: "sub",
  //             active: false,
  //             children: [
  //                 { path: `/blog/blog_details`, title: "Blog Details", type: "link" },
  //                 { path: `/blog/blog_single`, title: "Blog Single", type: "link" },
  //                 { path: `/blog/add_post`, title: "Add Post", type: "link" },
  //             ],
  //         },
  //         { path: `/faq/faq`, icon: "Danger", type: "link", active: false, title: "FAQ" },
  //         {
  //             title: "Job Search",
  //             icon: "Filter-2",
  //             id: 28,
  //             type: "sub",
  //             active: false,
  //             children: [
  //                 { path: `/job_search/card_view`, title: "Card View", type: "link" },
  //                 { path: `/job_search/list_view`, title: "List View", type: "link" },
  //                 { path: `/job_search/job_detail`, title: "Job Details", type: "link" },
  //                 { path: `/job_search/apply`, title: "Apply", type: "link" },
  //             ],
  //         },
  //         {
  //             title: "Learning",
  //             icon: "Work",
  //             id: 29,
  //             type: "sub",
  //             active: false,
  //             children: [
  //                 { path: `/learning/learning_list`, title: "Learning List", type: "link" },
  //                 { path: `/learning/learning_course`, title: "Learning Detailed", type: "link" },
  //             ],
  //         },
  //         {
  //             title: "Map",
  //             icon: "Discovery",
  //             type: "sub",
  //             id: 30,
  //             active: false,
  //             children: [
  //                 { path: `/map/google_map`, type: "link", title: "Google Map" },
  //                 { path: `/map/leaflet_map`, type: "link", title: "Leaflet Map" },
  //             ],
  //         },
  //         {
  //             title: "Editors",
  //             id: 31,
  //             icon: "Shield",
  //             type: "sub",
  //             active: false,
  //             children: [
  //                 { path: `/editor/quill_editor`, type: "link", title: "Quill editor" },
  //                 { path: `/editor/ace_editor`, type: "link", title: "ACE Code Editor" },
  //             ],
  //         },
  //         { id: 32, path: `/knowledgebase/knowledgebase`, icon: "Setting", type: "link", active: false, title: "Knowledgebase" },
  //         { id: 33, path: `/support_ticket/support_ticket`, icon: "Ticket", type: "link", active: false, title: "Support Ticket" },
  //     ],
  // },
];
